import React from 'react';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';

import { Text } from '../../../Components/Base';
import { FONT_SIZE, SPACE } from '../../../Components/Theme';
import RedeemForm from '../../../Containers/Redeem';

const Image = styled.img`
  max-height: 20vh;
  @media (min-width: 768px) {
    max-height: none;
  }
`;

const RedeemView = ({ initialValue, ...props }) => (
  <Flex flexDirection={'column'} alignItems={'center'}>
    <Box mb={SPACE.medium} style={{ textAlign: 'center' }}>
      <Image src="/images/redeem_empty.svg" />
      {/* <Text color="greyscale.grey3" fontSize={FONT_SIZE.semilarge}>
        ยังไม่พบข้อมูลการสมัครสอบ
      </Text> */}
    </Box>
    <RedeemForm defaultValue={initialValue} {...props} />
  </Flex>
);

export default RedeemView;
